import React from 'react';
import '../less/digital-skins.less'
import hero_img from '../img/hero_img.png';
import Hero from '../../../../../auxiliary-components/shared/HeroBlock';
import how_to_block_img_1 from '../img/how_to_block_img_1.png';
import how_to_block_img_2 from '../img/how_to_block_img_2.png';
import how_to_block_img_3 from '../img/how_to_block_img_3.png';
import HowToBlockNew from '../../../../../auxiliary-components/shared/HowToBlockNew';
import how_to_block_items from '../enums/how_to_block_items.json';
import additionalCards from '../enums/additional_cards.json';
import AdditionalProduct from '../../../../../auxiliary-components/shared/AdditionalProductBlock';
import InfoBlock from '../../../../../auxiliary-components/shared/InfoBlock';

export default function template() {
  const page = "digital-skins";

  const hero_data = {
    title: 'DIGITAL_SKINS_NEW_HERO_TITLE',
    text: 'DIGITAL_SKINS_NEW_HERO_TEXT',
  }

  const imagesMap = {
    how_to_block_img_1,
    how_to_block_img_2,
    how_to_block_img_3
  };

  const howToBlockItems = how_to_block_items.map(item => ({
    ...item,
    img: imagesMap[item.img]
  }));

  return (
    <div className="digital-skins">
      <Hero
        data={hero_data}
        img={hero_img}
        page={page}
        imgBottom
      />
      <div className="content">
        <div>
          <InfoBlock
            title={'DIGITAL_SKINS_NEW_INFO_TITLE'}
            middleText={'DIGITAL_SKINS_NEW_INFO_MIDDLE_TEXT'}
            text={'DIGITAL_SKINS_NEW_INFO_TEXT'}
          />
          <div className="where-display">
            <div className="container">
              <div className="where-display__body">
                <h3 className="where-display__title">{this.l10n('DIGITAL_SKINS_WHERE_DISPLAY_TITLE')}</h3>
                <div className="where-display__text">{this.l10n('DIGITAL_SKINS_WHERE_DISPLAY_TEXT')}</div>
              </div>
            </div>
          </div>
        </div>
        <div className="available-cards">
          <div className="container">
            <div className="available-cards__body">
              <h2 className="available-cards__title">{this.l10n('DIGITAL_SKINS_NEW_AVAILABLE_CARDS_TITLE')}</h2>
              <div className="available-cards__row">
                <div className="available-cards__item">{this.l10n('DIGITAL_SKINS_NEW_AVAILABLE_CARDS_ITEM_01')}</div>
                <div className="available-cards__item">{this.l10n('DIGITAL_SKINS_NEW_AVAILABLE_CARDS_ITEM_02')}</div>
                <div className="available-cards__item">{this.l10n('DIGITAL_SKINS_NEW_AVAILABLE_CARDS_ITEM_03')}</div>
                <div className="available-cards__item">{this.l10n('DIGITAL_SKINS_NEW_AVAILABLE_CARDS_ITEM_04')}</div>
                <div className="available-cards__item">{this.l10n('DIGITAL_SKINS_NEW_AVAILABLE_CARDS_ITEM_05')}</div>
              </div>
              <div className="available-cards__text">{this.l10n('DIGITAL_SKINS_NEW_AVAILABLE_CARDS_TEXT')}</div>
            </div>
          </div>
        </div>
        <HowToBlockNew
          title={'DIGITAL_SKINS_NEW_HOW_TO_TITLE'}
          items={howToBlockItems}
        />
        <AdditionalProduct
          items={additionalCards}
          title={'DIGITAL_SKINS_NEW_ADDITIONAL_PRODUCT_TITLE'}
        />
      </div>
    </div>
  );
}
